// Product data centralized for better management
export const solarStorageProducts = [
  {
    id: 'spethacs-room-a',
    name: 'Spethacs Room A',
    category: 'Hybrid-Powered Storage System',
    description: 'Compact hybrid-powered storage solution perfect for smallholder farmers looking to reduce post-harvest losses and increase income.',
    capacity: '500 kg',
    dimensions: '2m x 2m x 2.5m',
    powerRequirement: 'Hybrid power (Solar thermal, Solar PV, High Energy density Briquettes)',
    temperatureRange: '5°C - 25°C',
    humidityControl: '60% - 80%',
    installationTime: '4-6 hours',
    warranty: '2 years',
    bestFor: 'Small-scale farmers, individual plots, trial installations',
    price: 'Contact for pricing',
    image: 'pro1.jpeg',
    benefits: [
      'Reduces post-harvest loss by 80%',
      'Hybrid-powered operation',
      'Easy installation',
      'Low maintenance'
    ],
    features: [
      'Hybrid-powered operation',
      'Digital temperature display',
      'Mobile app monitoring',
      'Easy installation',
      'Low maintenance requirements',
      'Modular design for expansion'
    ],
    impact: [
      'Reduces post-harvest loss by up to 80%',
      'Extends shelf life of produce by 3-4 weeks',
      'Increases farmer income by 30-40%',
      'Environmentally friendly',
      'No electricity costs',
      'Quick ROI within 12-18 months'
    ],
    testimonials: [
      {
        farmer: 'John Mwangi',
        location: 'Kenya',
        text: 'The Spethacs Room A transformed my tomato farming. I used to lose 40% of my harvest, now I lose less than 10%.',
        rating: 5
      },
      {
        farmer: 'Amina Yusuf',
        location: 'Nigeria',
        text: 'Easy to install and maintain. My vegetables stay fresh for weeks, allowing me to sell at better prices.',
        rating: 5
      }
    ]
  },
  {
    id: 'spethacs-room-b',
    name: 'Spethacs Room B',
    category: 'Hybrid-Powered Storage System',
    description: 'Medium-capacity hybrid-powered storage solution designed for agricultural cooperatives and medium-sized farms.',
    capacity: '2,000 kg',
    dimensions: '4m x 4m x 3m',
    powerRequirement: 'Hybrid power (Solar thermal, Solar PV, High Energy density Briquettes)',
    temperatureRange: '3°C - 25°C',
    humidityControl: '50% - 85%',
    installationTime: '1-2 days',
    warranty: '3 years',
    bestFor: 'Agricultural cooperatives, medium-sized farms, community storage',
    price: 'Contact for pricing',
    image: 'pro2.jpeg',
    benefits: [
      'Climate control system',
      'Real-time monitoring',
      'Modular design',
      'Extended shelf life'
    ],
    features: [
      'Advanced climate control system',
      'Real-time monitoring dashboard',
      'Multiple storage zones',
      'Data analytics platform',
      'Remote management capabilities',
      'Backup power system'
    ],
    impact: [
      'Reduces post-harvest loss by up to 85%',
      'Extends shelf life by 4-6 weeks',
      'Increases collective income by 50-60%',
      'Supports multiple crop types',
      'Scalable solution',
      'Comprehensive reporting'
    ],
    testimonials: [
      {
        farmer: 'Cooperative Chair, Rwanda Farmers Union',
        location: 'Rwanda',
        text: 'Our cooperative serves 200 farmers. The Spethacs Room B has helped us collectively save over $50,000 in lost produce.',
        rating: 5
      }
    ]
  },
  {
    id: 'spethacs-room-c',
    name: 'Spethacs Room C',
    category: 'Hybrid-Powered Storage System',
    description: 'Large-scale commercial hybrid-powered storage solution for agricultural businesses and large farming operations.',
    capacity: '5,000 kg',
    dimensions: '8m x 6m x 4m',
    powerRequirement: 'Hybrid power (Solar thermal, Solar PV, High Energy density Briquettes)',
    temperatureRange: '2°C - 25°C',
    humidityControl: '40% - 90%',
    installationTime: '3-5 days',
    warranty: '5 years',
    bestFor: 'Commercial farms, food processing companies, large agricultural businesses',
    price: 'Contact for pricing',
    image: 'pro3.jpeg',
    benefits: [
      'Advanced climate control',
      'Digital analytics platform',
      'Multiple zones',
      'Commercial grade'
    ],
    features: [
      'Commercial-grade climate control',
      'Enterprise analytics platform',
      'Multiple independent zones',
      'Automated inventory management',
      'Integration with ERP systems',
      '24/7 technical support'
    ],
    impact: [
      'Reduces post-harvest loss by up to 90%',
      'Extends shelf life by 6-8 weeks',
      'Increases business revenue by 70-80%',
      'Supports export quality standards',
      'Full automation',
      'Comprehensive business intelligence'
    ],
    testimonials: [
      {
        farmer: 'Operations Manager, Fresh Produce Ltd',
        location: 'Ghana',
        text: 'The Spethacs Room C has been game-changing for our export business. We now meet international quality standards consistently.',
        rating: 5
      }
    ]
  }
];

export const smartPackagingProducts = [
  {
    id: 'smart-packaging-1',
    name: 'FreshGuard Bags',
    category: 'Smart Packaging',
    description: 'Reusable storage bags with built-in freshness indicators for small-scale produce storage.',
    dimensions: '30cm x 40cm',
    material: 'Multi-layer breathable polymer',
    lifespan: '50 uses',
    bestFor: 'Vegetables and fruits',
    price: '$5-10 per unit',
    image: '/images/freshguard-bags.jpg',
    features: [
      'Built-in freshness sensors',
      'Breathable material',
      'UV protection',
      'Reusable up to 50 times'
    ],
    impact: [
      'Extends freshness by 2-3 weeks',
      'Reduces packaging waste by 90%',
      'Visual freshness indicators',
      'Cost-effective solution',
      'Environmentally friendly',
      'Easy to transport'
    ],
    testimonials: [
      {
        farmer: 'Grace Okonkwo',
        location: 'Nigeria',
        text: 'FreshGuard bags have revolutionized how I store and transport my vegetables. Customers love the freshness!',
        rating: 5
      }
    ]
  },
  {
    id: 'smart-packaging-2',
    name: 'CrispKeep Containers',
    category: 'Smart Packaging',
    description: 'Smart containers with automatic humidity control and mobile app integration.',
    dimensions: '25cm x 25cm x 15cm',
    material: 'Food-grade plastic with sensors',
    lifespan: '5 years',
    bestFor: 'Leafy greens and herbs',
    price: '$15-25 per unit',
    image: '/images/crispkeep-containers.jpg',
    features: [
      'Automatic humidity regulation',
      'Temperature monitoring',
      'Mobile app integration',
      'Stackable design'
    ],
    impact: [
      'Maintains optimal humidity automatically',
      'Real-time monitoring via app',
      'Extends shelf life by 3-4 weeks',
      'Reduces manual checking',
      'Perfect for premium markets',
      'Traceability features'
    ],
    testimonials: [
      {
        farmer: 'David Kimani',
        location: 'Kenya',
        text: 'Perfect for my premium herbs. The app tells me exactly when conditions are optimal.',
        rating: 5
      }
    ]
  },
  {
    id: 'smart-packaging-3',
    name: 'AgriShield Crates',
    category: 'Smart Packaging',
    description: 'Durable transport crates with GPS tracking and impact sensors for bulk transportation.',
    dimensions: '60cm x 40cm x 30cm',
    material: 'Reinforced polymer with electronics',
    lifespan: '10 years',
    bestFor: 'Bulk transportation',
    price: '$30-50 per unit',
    image: '/images/agrishield-crates.jpg',
    features: [
      'GPS tracking',
      'Impact sensors',
      'Ventilation system',
      'Heavy-duty construction'
    ],
    impact: [
      'Real-time shipment tracking',
      'Damage prevention alerts',
      'Optimal ventilation during transport',
      'Reduces transport losses by 70%',
      'Insurance claim documentation',
      'Supply chain transparency'
    ],
    testimonials: [
      {
        farmer: 'Logistics Manager, FarmCo',
        location: 'Tanzania',
        text: 'AgriShield crates have eliminated our transport damage issues. The GPS tracking gives us peace of mind.',
        rating: 5
      }
    ]
  }
];

// Get all products
export const getAllProducts = () => {
  return [...solarStorageProducts, ...smartPackagingProducts];
};

// Get product by ID
export const getProductById = (id) => {
  return getAllProducts().find(product => product.id === id);
};
